"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _constants = require("./constants");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'ConfigProvider'
});
schema.propTypes = {
  theme: _reactDesc.PropTypes.object.description('Overrides to the default theme').defaultValue("`{ mode: 'light' }`"),
  translations: _reactDesc.PropTypes.object.description('Overrides to the default translations'),
  linkRenderer: _reactDesc.PropTypes.func.description('A function that must return the component to use and style as a link'),
  portalsRoot: _reactDesc.PropTypes.any.description('A CSS selector matching the DOM node where portals should be rendered').format('string or HTMLElement').defaultValue("`'".concat(_constants.PORTALS_ROOT_SELECTOR, "'`")),
  extraScope: _reactDesc.PropTypes.string.description('A CSS selector to include as a prefix to all generated CSS class names')
};
var _default = schema;
exports.default = _default;